import { Injectable } from '@angular/core';
import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app
export enum DA_FEATURE_FLAGS {
    DRIVER_HUB_ENABLED = 'driver-hub-enabled',
}

@Injectable({ providedIn: 'root' })
export class DriverAppFeatureFlagService {
  constructor(private statsigService: StatsigService) {}

  public isDriverHubEnabled(): boolean {
    return this.statsigService
      .evaluateGate(DA_FEATURE_FLAGS.DRIVER_HUB_ENABLED);
  }
}
